import React from 'react';
import { SkaldScribeLaunchBanner } from './SkaldScribeLaunchBanner';

export const PublicSiteLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <>
    <SkaldScribeLaunchBanner />
    {children}
  </>
);

export function withPublicSiteLayout(Component: React.ComponentType): React.FC {
  const Wrapped: React.FC = () => (
    <PublicSiteLayout>
      <Component />
    </PublicSiteLayout>
  );
  Wrapped.displayName = `PublicSiteLayout(${Component.displayName ?? Component.name ?? 'Page'})`;
  return Wrapped;
}
